import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { FilterIcon } from '../../../common/icons';
import { IconButton } from '../../../common/IconButton';
import { RouterTab } from '../../../common/RouterTab';
import { Options } from '../../IDE/components/Header/MobileNav';
import { toggleDirectionForField } from '../../IDE/actions/sorting';
import useIsMobile from '../../IDE/hooks/useIsMobile';

export enum TabKey {
  assets = 'assets',
  sketches = 'sketches',
  shared = 'shared',
  examples = 'examples'
}

// It is good for right now, because we need to separate the nav dropdown logic from the navBar before we can use it here
const FilterOptions = styled(Options)`
  > div > button:focus + ul,
  > div > ul > button:focus ~ div > ul {
    transform: scale(1);
    opacity: 1;
  }
`;

export interface DashboardTabSwitcherProps {
  currentTab: TabKey;
  isOwner: string;
  username: string;
}
export const DashboardTabSwitcher = ({
  currentTab,
  isOwner,
  username
}: DashboardTabSwitcherProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div className="dashboard-header__switcher">
      <ul className="dashboard-header__tabs">
        <RouterTab to={`/${username}/sketches`}>
          {t('DashboardTabSwitcher.Sketches')}
        </RouterTab>
        {isOwner && (
          <RouterTab to={`/${username}/assets`}>
            {t('DashboardTabSwitcher.Assets')}
          </RouterTab>
        )}
        {isOwner && (
          <RouterTab to={`/${username}/shared`}>
            {t('DashboardTabSwitcher.Shared', {
              defaultValue: 'Shared with me'
            })}
          </RouterTab>
        )}
        {/* Global (not per-user): the curated AR examples list, visible to everyone. */}
        <RouterTab to="/examples">
          {t('DashboardTabSwitcher.Examples', { defaultValue: 'AR Examples' })}
        </RouterTab>
      </ul>
      {isMobile &&
        currentTab !== TabKey.assets &&
        currentTab !== TabKey.examples && (
          <FilterOptions>
            <div>
              <IconButton icon={FilterIcon} />
              <ul>
                <li>
                  <button
                    onClick={() => dispatch(toggleDirectionForField('name'))}
                  >
                    {t('CollectionList.HeaderName')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      dispatch(toggleDirectionForField('createdAt'))
                    }
                  >
                    {t('CollectionList.HeaderCreatedAt')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      dispatch(toggleDirectionForField('updatedAt'))
                    }
                  >
                    {t('CollectionList.HeaderUpdatedAt')}
                  </button>
                </li>
              </ul>
            </div>
          </FilterOptions>
        )}
    </div>
  );
};
